import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';

const title = environment ? environment.appTitle : 'Application Title';
const routes: Routes = [

  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...BaseRoutes.getEntityRoutes(
        title,
        'customersupplier',
        () => import('./customersupplier/customer-supplier.module').then(m => m.CustomerSupplierModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'item',
        () => import('./item/item.module').then(m => m.ItemModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'order',
        () => import('./order/order.module').then(m => m.OrderModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'emissionorder',
        () => import('./emission-order/emission-order.module').then(m => m.EmissionOrderModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ]
  ),
  // #endregion rotte con autenticazione

  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
